<script>
  import UploadForm from "App/components/Verification/UploadForm";
  import VerificationApi from "App/api/VerificationApi";
  import ApiErrorHandler from "App/api/ApiErrorHandler";
  import StepsProgress from "./StepsProgress.svelte";

  export let onError;
  export let onSuccess;

  async function submitUtilityBill({ file }) {
    try {
      let { ok, error } = await VerificationApi().uploadUtilityBill(file);
      if (ok) {
        onSuccess();
      } else {
        onError(error);
      }
    } catch (ex) {
      ApiErrorHandler(ex);
    }
  }
</script>

<StepsProgress activeStep="utility_bill" />

<p class="title">Upload utility bill</p>
<p class="subtitle">
  Please upload a photo copy of a utility bill (PNG, JPG, PDF up to 10MB)
</p>
<UploadForm onSubmitValid="{submitUtilityBill}" />
